export class QueryModel {
  motivoId: number;
  descripcion: string;
  respuestaId: number;
  archivo: File;

  constructor() {
    this.motivoId = 0;
    this.descripcion = '';
    this.respuestaId = null;
    this.archivo = null;
  }
}
